import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheet } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useDataRoomTermSheetsQuery(
	dataRoomGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<TermSheet[], unknown, TermSheet[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.List(dataRoomGuid),
		() => AxiosUtils.getResponseData<TermSheet[]>(api.get(CerebroApiEndpoints.TermSheets.List(dataRoomGuid))),
		options
	);
}
